export default function shortenComments(elementHeight, shortenClass, commentReviewState) {
    const { showLessButtonText, readMoreButtonText } = commentReviewState;
    const reviews = document.querySelectorAll('.js-userCommentReview, .js-agencyReplies');

    reviews.forEach((reviewElement) => {
        const button = reviewElement.querySelector('.js-commentReadMore');
        const readMoreBar = reviewElement.querySelector('.js-barReadMore');

        if (reviewElement.offsetHeight > elementHeight) {
            reviewElement.classList.add(shortenClass);
            readMoreBar.style.display = 'block';
            button.textContent = readMoreButtonText;
        }

        // sa onclick smo osigurali da se isti event handler ne zakači na elemente na kojima je već postavljen,
        // jer u slučaju dohvaćanja novih review-ova preko ajaxa pokrećemo ovu funkciju za stare i nove review elemente.
        button.onclick = () => {
            if (reviewElement.classList.contains(shortenClass)) {
                reviewElement.classList.remove(shortenClass);
                button.textContent = showLessButtonText;
            } else {
                reviewElement.classList.add(shortenClass);
                button.textContent = readMoreButtonText;
            }
        };
    });
}
